import { createRecipe } from './runtime';

const arrowTagConfig = {"name":"arrowTag"}

export const arrowTag = /* @__PURE__ */ createRecipe(arrowTagConfig)